import script from "./MallFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MallFooter.vue?vue&type=script&setup=true&lang=js"

import "./MallFooter.vue?vue&type=style&index=0&id=83f7ae30&scoped=true&lang=css"
import "./MallFooter.vue?vue&type=style&index=1&id=83f7ae30&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f7ae30"]])

export default __exports__